import { useRef,useLayoutEffect, useState } from 'react';
import InsightExpanded from './InsightExpanded'
import { IoIosArrowDropdown, IoIosArrowDropup } from 'react-icons/io';
export default function InsightItem({ insight, expandedData, isExpanded, isLoading, onClick, isRead }) {
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState("0px");
//console.log("expandedData", expandedData, "isExpanded", isExpanded, "isLoading", isLoading);
 // const isRead = insight?.is_already_viewed;

  useLayoutEffect(() => {
    if (isExpanded && contentRef.current) {
      setMaxHeight(contentRef.current.scrollHeight + "px");
    } else {
      setMaxHeight("0px");
    }
  }, [isExpanded, expandedData]);

  //console.log("expandedData",expandedData)

  return (
    <div className="d-flex flex-column gap-1 mb-3">
      <p className="small text-muted text-start">
        {new Date(insight.created_at).toLocaleString('sv-SE', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        })}
      </p>

      <div
        className="rounded bg-white overflow-hidden"
        style={{
          border: isRead ? "1px solid #6c757d" : "1px solid #6AB2A0",
          transition: "border-color 0.3s",
        }}
      >
        <div
          className="d-flex align-items-center w-100"
          onClick={onClick}
          style={{ cursor: "pointer" }}
        >
          <div
            className={`d-flex align-items-center ms-3 flex-grow-1 px-1 py-2 small ${
              isRead ? "text-muted" : "fw-semibold text-dark"
            }`}
          >
            {insight.insight_subject}
          </div>

          <div
            className="d-flex align-items-center justify-content-center px-3 text-white"
            style={{
              backgroundColor: isRead ? "#6c757d" : "#6AB2A0",
              alignSelf: "stretch",
            }}
          >
            {isExpanded ? (
              <IoIosArrowDropup size={32} />
            ) : (
              <IoIosArrowDropdown size={32} />
            )}
          </div>
        </div>

        <div
          ref={contentRef}
          className="overflow-hidden"
          style={{
            maxHeight,
            transition: "max-height 0.3s ease",
          }}
        >
        
<div className="px-3 pb-3 pt-1 small text-secondary">
  {isLoading ? (
    <div className="text-center py-4">
      <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900"></div>
      <p className="text-gray-500 mt-2">Loading details...</p>
    </div>
  ) : expandedData ? (
    <InsightExpanded insight={expandedData} />
  ) : isExpanded ? (
    "Loading..."
  ) : null}
</div>
        </div>
      </div>
    </div>
  );
}
